import { render, staticRenderFns } from "./GlobalSubPhases.vue?vue&type=template&id=3c982407&scoped=true&"
import script from "./GlobalSubPhases.vue?vue&type=script&lang=ts&"
export * from "./GlobalSubPhases.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c982407",
  null
  
)

export default component.exports